import { environment } from "../../environments/environment";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, timeout, catchError, tap, switchMap } from 'rxjs/operators';
import { BehaviorSubject, from, Observable, Subject } from 'rxjs';
import { take } from "rxjs/operators";
import { 
	StorageService, 
	TOKEN, 
	CURRENT_USER, 
	SERVER_TIMESTAMP, 
	LocalDataset
} from "./storage.service";
import { CurrentUser, DeliveryLog, Guest, QueueLog, DeliverySender, Service, TenantLocation, User, Tag } from "@/_models";
import { AuthService } from "./auth.service";

type DatasetItem = {
	name: keyof AppDataService;
	data: any;
};

@Injectable({
	providedIn: 'root'
})
export class AppDataService {

	queuelogsLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	updateAvailable: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	isLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
	
	// Data Subjects
	queueLogs: BehaviorSubject<QueueLog[]> = new BehaviorSubject<QueueLog[]>([]);
	stations: BehaviorSubject<Object> = new BehaviorSubject<Object>([]);
	services: BehaviorSubject<Service[]> = new BehaviorSubject<Service[]>([]);
	guests: BehaviorSubject<Guest[]> = new BehaviorSubject<Guest[]>([]);
	users: BehaviorSubject<User[]> = new BehaviorSubject<User[]>([]);
	tags: BehaviorSubject<Tag[]> = new BehaviorSubject<Tag[]>([]);

	datasets: any = [
		'queueLogs', 
		'stations',
		'services', 
		'guests', 
		'users', 
		'tags' 
	]

	constructor(
		private auth: AuthService,
		private storage: StorageService,
	) {
		// console.log('init appDataService');
		this.loadAppData(this.datasets); // for refreshers
	}


	setAppData(dataset?: any) {
		// console.log('==============setAppData=============');
		// console.log('setAppData', dataset);
		dataset.map((el: DatasetItem) => {
			// console.log('set ' + el.name, this[el.name].value);
			(this[el.name] as any).next(el.data);
		});
	}
	
	unsetAppData() {
		this.isLoaded.next(false);
		this.updateAvailable.next(false);
		this.queuelogsLoaded.next(false);
		this.datasets.map((el: keyof AppDataService) => {
			(this[el] as BehaviorSubject<any>).next([]);
		});
	}

	async loadAppData(subjects: any[]) {
		// console.log('start loadAppData ==============>');
		const loadOp = subjects.map(async (el: keyof AppDataService) => {
			await this.storage.getObject(el).then((data) => {
				(this[el] as any).next(data);
				if (el === 'queueLogs') {
					this.queuelogsLoaded.next(true);
				}
			});
		});
		await Promise.all(loadOp).then(() => {
			this.isLoaded.next(true);
			// console.log('end loadAppData ==============>');			
		});
	}

	async syncData() {
		this.auth
			.syncAppData({ 
				timestamp: this.auth.serverTimestamp.value,
				locationId: this.auth.currentUser.value.selectedLocation.id
			 })
			.pipe(take(1))
			.subscribe((res) => {
				// console.log('syncData', res)
				this.storage.syncStoredData(res.dataset, res.serverTimestamp).then(() => {
					this.auth.serverTimestamp.next(res.serverTimestamp);
					this.syncAppData(res.dataset);
					// console.log('syncAppData');
				});
			});
	}

	syncAppData(dataset?: any) {
		dataset.map((item: DatasetItem) => {
			if (item.data.length > 0) {
				this.storage.getObject(item.name).then((data) => {
					(this[item.name] as any).next(data);
					// console.log('synced ' + el.name, this[el.name].value);
				})
			}
		});
	}

	getQueueLogs(): Observable<QueueLog[]> {
		return this.queueLogs.asObservable();
	}

	getServices(): Observable<Service[]> {
		return this.services.asObservable();
	}

	getGuests(): Observable<Guest[]> {
		return this.guests.asObservable();
	}

	getUsers(): Observable<User[]> {
		return this.users.asObservable();
	}

	getTags(): Observable<Tag[]> {
		return this.tags.asObservable();
	}

	// getDeliveryLogs(): Observable<DeliveryLog[]> {
	// 	return this.deliveryLogs.asObservable();
	// }

}
